export const MODAL_ADVANCED_OPTIONS_SET_OPEN = 'MODAL_ADVANCED_OPTIONS_SET_OPEN';
